import React, { useState } from "react";
import PropTypes from "prop-types";
import Offcanvas from "react-bootstrap/Offcanvas";
//import OptionAppMenu from "./OptionAppMenu";
import SectionAhorro from "./SectionAhorro";
import SectionSeguros from "./SectionSeguros";
import SectionSobre from "./SectionSobre";
import OptionNav from "../OptionNav/OptionNav";
import useMediaQuery from "app/hooks/useMediaQuery";
import "./AppMenu.css";

LeftSecondaryMenu.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  section: PropTypes.number,
  closeLeft: PropTypes.func,
  iconUrl: PropTypes.string,
};

function LeftSecondaryMenu({
  name = "",
  title = "",
  section = 0,
  closeLeft = () => {},
  iconUrl = "",
  ...props
}) {
  const is4K = useMediaQuery("(min-width: 3840px)");
  const isPhone = useMediaQuery("(max-width: 767px)");

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const showSectionMenu = (section, title) => {
    if (section === 1) {
      return (
        <SectionAhorro
          title={title}
          setShow={setShow}
          closeLeft={closeLeft}
          sectionIcon={iconUrl}
        />
      );
    }
    if (section === 2) {
      return (
        <SectionSeguros
          title={title}
          setShow={setShow}
          closeLeft={closeLeft}
          sectionIcon={iconUrl}
        />
      );
    }
    if (section === 3) {
      return (
        <SectionSobre
          title={title}
          setShow={setShow}
          closeLeft={closeLeft}
          sectionIcon={iconUrl}
        />
      );
    }
  };

  return (
    <div className="d-flex">
      <OptionNav
        name={name}
        title={title}
        url=""
        onClick={""}
        textColor="#fff"
        hasOptions={true}
        icon={iconUrl}
      />
      <Offcanvas
        backdrop={false}
        className={`${is4K && "offcanvas-4K"}`}
        show={show}
        onHide={handleClose}
        style={{
          backgroundColor: "#f1f1f1",
          color: "#001a70",
          marginTop: isPhone ? "0px" : "54px",
          marginLeft: isPhone ? "0px" : "398px",
          zIndex: isPhone ? 1055 : 1044,
        }}
        {...props}
      >
        <Offcanvas.Body
          style={{
            padding: isPhone && "0px",
            margin: isPhone && "0px",
          }}
        >
          {isPhone ? (
            <div className="d-flex blue-shore" onClick={handleClose}>
              <div className="arrow-left ms-3 mt-5"></div>
              <div className="content-menu-mobile">
                {showSectionMenu(section, title)}
              </div>
            </div>
          ) : (
            showSectionMenu(section, title)
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}

export default LeftSecondaryMenu;
